import { useEffect } from 'react';

/**
 * Sets a `data-theme-ready` attribute on <html> after first paint, so the
 * global theme transition (see globals.css) only applies after hydration.
 * Without this guard the page would paint with a transition on the very first
 * frame, briefly flashing colours as the dark/light class settles.
 */
export function ThemeReady() {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme-ready', '');
  }, []);
  return null;
}
